
<div *ngIf="loading === 0" class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <dx-form #form1 [labelLocation]="'top'" [colCount]="1" [(formData)]="init_data.einrichtung" [items]="formItems">

                <div *dxTemplate="let gesamtCountDataForm of 'gesamtCountTemplate'">
                    <div class="dx-first-col dx-last-col dx-field-item dx-col-0 dx-field-item-optional dx-field-item-label-align dx-flex-layout dx-label-h-align">
                        <label class="dx-field-item-label dx-field-item-label-location-left"><span class="dx-field-item-label-content" style="width: 420px;"><span class="dx-field-item-label-text">Gesamt genehmigt:</span></span></label>
                        <div class="dx-field-item-content dx-field-item-content-location-bottom">
                            <div class="dx-texteditor-container">
                                <div class="row">
                                    <div class="col-sm-3 col-md-3 text-right">
                                        Plätze:
                                    </div>
                                    <div class="col-md-9 col-sm-9">
                                        {{getAllPlaetze}}
                                    </div>
                                    <div class="col-sm-3 col-md-3 text-right">
                                        Leitung:
                                    </div>
                                    <div class="col-sm-3 col-md-3">
                                        {{getAllLeitStellen}}
                                    </div>
                                    <div class="col-sm-3 col-md-3 text-right">
                                        pädagogische:
                                    </div>
                                    <div class="col-sm-3 col-md-3">
                                        {{getAllPaedStellen}}
                                    </div>
                                    <div class="col-sm-3 col-md-3 text-right">
                                        psychische:
                                    </div>
                                    <div class="col-sm-3 col-md-3">
                                        {{getAllPsychStellen}}
                                    </div>
                                    <div class="col-sm-3 col-md-3 text-right">
                                        therapeutische:
                                    </div>
                                    <div class="col-sm-3 col-md-3">
                                        {{getAllTherapStellen}}
                                    </div>
                                    <div class="col-sm-3 col-md-3 text-right">
                                        sonstige:
                                    </div>
                                    <div class="col-sm-3 col-md-3">
                                        {{getAllSonstigeStellen}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div *dxTemplate="let boolGiltFuerGesamtDataForm of 'boolGiltFuerGesamtTemplate'">
                    <div class="dx-first-col dx-last-col dx-field-item dx-col-0 dx-field-item-optional dx-field-item-label-align dx-flex-layout dx-label-h-align">
                        <label class="dx-field-item-label dx-field-item-label-location-left">
                            <span class="dx-field-item-label-content" style="width: 420px;">
                                <span class="dx-field-item-label-text"></span>
                            </span>
                        </label>
                        <div class="dx-field-item-content dx-field-item-content-location-bottom">
                            <div class="dx-texteditor-container">
                                <div class="row" style="margin-top: 10px;">
                                    <div class="col-md-6">
                                        <dx-check-box text="nicht veränderbar"
                                                      [value]="notEditable"
                                                      (onValueChanged)="notEditable_checkBox_valueChanged($event)">
                                        </dx-check-box>
                                    </div>
                                    <div class="col-md-6">
                                        <dx-check-box text="nicht automatisch aktualisieren"
                                                      [value]="notAutoUpdate"
                                                      (onValueChanged)="notAutoUpdate_checkBox_valueChanged($event)">
                                        </dx-check-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </dx-form>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div *ngIf="loading === 1" class="text-center">
                <h1>Lade...</h1>
            </div>
            <div *ngIf="loading === 2" class="text-center">
                <h1>Speichere...</h1>
            </div>
        </div>
    </div>
</div>
